<template>
  <div class="navbar-container d-flex content align-items-center navScroll">
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      lazy
      :sidebar-class="
        useTelegram
          ? 'telegram-resource-sidebar telegram-connection-sidebar'
          : 'sidebar-lg'
      "
      :width="telegramSidebarWidth"
      right
      no-header
      backdrop
      shadow
    >
      <template v-if="!useTelegram">
        <!-- @hidden="checkStatus()" -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <!-- <h5 v-if="showError" class="mb-0">Unable to connect!</h5> -->
          <template>
            <h5
              class="mb-0"
              v-if="
                this.waObj != null &&
                this.waObj.qrCode == '' &&
                !this.waObj.connected
              "
            >
              {{ $t("Connecting to WhatsApp") }} ⏳
            </h5>
            <h5
              class="mb-0"
              v-if="
                this.waObj != null &&
                this.waObj.qrCode != '' &&
                !this.waObj.connected
              "
            >
              {{ $t("Please Scan the QR Code") }} 📱
            </h5>
            <h5 class="mb-0" v-if="this.waObj != null && this.waObj.connected">
              {{ $t("Connected") }} ✔️
            </h5>
          </template>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hideSideBar()"
          />
        </div>
        <b-form class="p-2" @submit.prevent>
          <b-row>
            <!-- Animation Loading -->
            <!-- <b-col md="12" v-if="showError">
            <b-button variant="primary" block @click="showSidebar()">
              Try Again
            </b-button>
          </b-col> -->
            <b-col
              md="12"
              v-if="
                this.waObj == null ||
                (this.waObj.qrCode == '' && !this.waObj.connected)
              "
            >
              <div md="12" style="height: 300px">
                <lottie-animation path="wa-loading.json" />
              </div>

              <b-button
                v-if="false"
                variant="primary"
                block
                :disabled="disRetry"
                @click="loadRetry()"
              >
                {{ $t("Retry") }}
                {{ formatRetryText(retryCount) }}
              </b-button>
            </b-col>

            <!-- Animation Connected -->
            <b-col md="12" v-if="this.waObj != null && this.waObj.connected">
              <div md="12" style="height: 300px">
                <lottie-animation path="connected.json" />
              </div>
              <b-button
                :to="{ name: 'apps-chat' }"
                variant="success"
                block
                v-if="showSendMsg"
              >
                {{ $t("Start Sending Messages") }}
              </b-button>
            </b-col>

            <!-- Video -->
            <b-col
              md="12"
              v-if="
                this.waObj != null &&
                this.waObj.qrCode != '' &&
                !this.waObj.connected
              "
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div md="12">
                <div md="12">
                  <!-- <h5 style="width: 100%">Scan QR Code</h5> -->
                  <video
                    style="width: 98%"
                    autoplay="true"
                    muted
                    controls=""
                    controlslist="nodownload"
                  >
                    <source
                      src="https://cdn.cloudious.net/file-1775540967514-793616240.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </b-col>

            <!-- QR Code -->
            <b-col
              md="12"
              class="mt-5"
              v-if="
                this.waObj != null &&
                this.waObj.qrCode != '' &&
                !this.waObj.connected
              "
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div md="12">
                <!-- <h5 style="width: 100%">Scan QR Code</h5> -->
                <!-- &&
                  this.$store.state.WAdomain.includes('api.whatsappbusiness.ae') -->
                <b-img
                  :src="
                    this.$store.state.WAdomain
                      ? this.waObj.qrCode
                      : this.waObj.qrCode
                  "
                  fluid
                  style="width: 300px; height: 300px; display: flex"
                  alt="qr_code"
                />
              </div>
            </b-col>

            <b-col md="12" v-if="false">
              <b-button
                v-i
                variant="primary"
                :disabled="qrLoading"
                class="mt-2 ml-2 mr-2"
                style="width: 90%"
                @click="GetQRCode()"
              >
                <div v-if="qrLoading">
                  <b-spinner
                    small
                    variant="light"
                    type="grow"
                    label="Spinning"
                  ></b-spinner>
                </div>
                <span v-else>{{ $t("Get New QR Code") }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </template>

      <template v-else>
        <div class="telegram-sidebar-wrapper">
          <template v-if="statusW && statusW.toLowerCase() === 'connected'">
            <div class="sidebar-header-modern">
              <div class="sidebar-header-content">
                <div class="sidebar-title-wrapper">
                  <feather-icon
                    icon="CheckCircleIcon"
                    size="20"
                    class="sidebar-title-icon telegram-sidebar-icon-success"
                  />
                  <h5 class="mb-0 sidebar-title">{{ $t("Connected") }}</h5>
                </div>
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="sidebar-close-btn"
                  @click="hideSideBar()"
                >
                  <feather-icon icon="XIcon" size="16" />
                </b-button>
              </div>
            </div>
            <div class="sidebar-body-modern">
              <p class="telegram-connect-lead mb-4">
                {{ $t("Telegram is connected.") }}
              </p>
              <b-button
                v-if="showSendMsg"
                :to="{ name: 'apps-chat' }"
                variant="gradient-primary"
                block
                class="modern-btn-primary mb-2"
              >
                <feather-icon icon="MessageSquareIcon" size="16" class="mr-1" />
                <span>{{ $t("Start Sending Messages") }}</span>
              </b-button>
              <b-button
                variant="outline-danger"
                block
                class="modern-btn-outline"
                :disabled="tgConnectLoading || tgVerifyLoading"
                @click="telegramDisconnectFromSidebar"
              >
                <feather-icon icon="LogOutIcon" size="16" class="mr-1" />
                <span>{{ $t("Disconnect Telegram") }}</span>
              </b-button>
            </div>
          </template>

          <template v-else>
            <div class="sidebar-header-modern">
              <div class="sidebar-header-content">
                <div class="sidebar-title-wrapper">
                  <feather-icon
                    icon="SendIcon"
                    size="20"
                    class="sidebar-title-icon"
                  />
                  <h5 class="mb-0 sidebar-title">
                    {{ $t("Connect Telegram") }}
                  </h5>
                </div>
                <b-button
                  variant="outline-secondary"
                  size="sm"
                  class="sidebar-close-btn"
                  @click="hideSideBar()"
                >
                  <feather-icon icon="XIcon" size="16" />
                </b-button>
              </div>
            </div>
            <div class="sidebar-body-modern">
              <b-form @submit.prevent class="sidebar-form-modern">
                <p class="telegram-connect-lead">
                  <span class="d-block">{{
                    $t(
                      "Choose your country code and enter your Telegram phone number."
                    )
                  }}</span>
                  <span class="d-block telegram-connect-lead-sub mt-1">{{
                    $t("Use search to find your country quickly.")
                  }}</span>
                </p>

                <b-form-group
                  v-if="!tgOtpStep"
                  :label="$t('Phone number')"
                  label-for="tg-tel-input"
                  class="modern-form-group"
                  :invalid-feedback="$t('Please enter a valid phone number')"
                  :state="tgPhoneFeedbackState"
                >
                  <div class="telegram-tel-wrap">
                    <vue-tel-input
                      id="tg-tel-input"
                      v-model="tgPhone"
                      mode="international"
                      :autoFormat="false"
                      :allCountries="tgTelEnglishCountries"
                      :inputOptions="tgTelInputOptions"
                      :dropdownOptions="tgTelDropdownOptions"
                      :defaultCountry="$store.state.countryCode || 92"
                      :disabled="tgConnectLoading || tgVerifyLoading"
                      @input="onTelegramPhoneInput"
                    />
                  </div>
                </b-form-group>

                <b-form-group
                  v-else
                  :label="$t('Verification code')"
                  label-for="tg-code-input"
                  class="modern-form-group"
                >
                  <b-form-input
                    id="tg-code-input"
                    v-model="tgCode"
                    maxlength="12"
                    class="modern-input"
                    :placeholder="$t('Enter code from Telegram')"
                    :disabled="tgVerifyLoading"
                    autocomplete="one-time-code"
                  />
                </b-form-group>

                <div v-if="!tgOtpStep" class="sidebar-footer-modern">
                  <b-button
                    variant="gradient-primary"
                    block
                    class="modern-btn-submit"
                    :disabled="!telegramPhoneValid || tgConnectLoading"
                    @click="telegramSendCode"
                  >
                    <b-spinner
                      v-if="tgConnectLoading"
                      small
                      type="grow"
                      class="mr-1"
                    />
                    <template v-else>
                      <feather-icon icon="MailIcon" size="16" class="mr-1" />
                      <span>{{ $t("Send verification code") }}</span>
                    </template>
                  </b-button>
                </div>

                <div
                  v-else
                  class="sidebar-footer-modern telegram-verify-footer"
                >
                  <b-button
                    variant="gradient-primary"
                    block
                    class="modern-btn-submit mb-2"
                    :disabled="!tgCode.trim() || tgVerifyLoading"
                    @click="telegramVerifyCode"
                  >
                    <b-spinner
                      v-if="tgVerifyLoading"
                      small
                      type="grow"
                      class="mr-1"
                    />
                    <template v-else>
                      <feather-icon icon="CheckIcon" size="16" class="mr-1" />
                      <span>{{ $t("Verify and connect") }}</span>
                    </template>
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    block
                    size="sm"
                    class="modern-btn-outline"
                    :disabled="tgVerifyLoading"
                    @click="telegramResetPhoneStep"
                  >
                    {{ $t("Use a different number") }}
                  </b-button>
                </div>
              </b-form>
            </div>
          </template>
        </div>
      </template>
    </b-sidebar>

    <b-modal
      id="modal-campuses"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      :title="$t('Business')"
      body-class="p-0"
    >
      <div class="pt-2 pl-2 pr-2 pb-0">
        <b-form-group :label="$t('Search')" ref="search">
          <b-form-input
            v-model="searchQuery"
            :placeholder="$t('enter name to search')"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="scrollContent">
        <h5
          v-for="item in filteredOptions"
          :key="item.id"
          class="pt-50 pb-50 pl-2 pr-2 font-weight-300 mb-0 cursor-pointer"
          :class="[
            item.id == current && 'text-white bg-primary',
            item.id != current && 'search-type',
          ]"
        >
          <!-- @click="ChangeBranch(item)" -->
          {{ item.branch }}
        </h5>
      </div>
    </b-modal>

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <!-- <vertical-nav-menu-items
      :items="navMenuItems"
      class="navigation navigation-main"
    /> -->
    <div class="nav-buttons-wrapper" ref="navButtonsWrapper">
      <div class="nav-buttons-container" ref="navButtonsContainer">
        <b-button
          class="nav-module-btn"
          v-for="(item, index) in menuItems"
          :key="item.route || index"
          :data-nav-route="item.route"
          :variant="
            routeVariant(item.route) ? 'outline-light' : 'outline-secondary'
          "
          :class="[
            routeVariant(item.route) && 'btn-gradient-primary',
            pendingNavRoute === item.route && 'is-pending',
          ]"
          @mouseenter="prefetchTab(item.route)"
          @focus="prefetchTab(item.route)"
          @click="onTopTabClick(item, $event)"
        >
          <span v-if="textAdjust">{{ $t(item.title).substr(0, 3) }}</span>
          <span v-else>{{ $t(item.title) }}</span>
        </b-button>
      </div>
      <div
        class="nav-switch-bar"
        :class="{ 'is-active': !!pendingNavRoute }"
        aria-hidden="true"
      />
    </div>

    <!-- Left Col -->
    <!-- <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">

      <bookmarks />
    </div> -->

    <b-navbar-nav
      class="nav align-items-center justify-content-end ml-auto adjustAlign"
    >
      <b-dropdown
        v-if="campusList.length > 1"
        class="adjust-dropdown"
        split
        size="sm"
        variant="outline-primary"
        :text="branchName"
        right
        :disabled="changingDb"
      >
        <b-dropdown-item
          v-for="(d, ind) in campusList"
          :key="ind"
          @click="ChangeDB(d)"
          :active="
            current == d.id && $store.state.userData.db == d.organizationType
              ? true
              : false
          "
        >
          {{ d.branch }}
        </b-dropdown-item>

        <b-dropdown-divider />
      </b-dropdown>

      <b-dropdown
        v-else-if="
          this.$store.state.userData.roles == 'administrator' ||
          this.$store.state.userData.roles == 'admin' ||
          showCampus
        "
        class="adjust-dropdown"
        split
        size="sm"
        variant="outline-primary"
        :text="branchName"
        right
        @shown="setFocus"
      >
        <!-- @show="testing" -->
        <b-dropdown-text>
          <b-form-input
            ref="searchInput"
            size="sm"
            v-model="searchQuery"
            :placeholder="$t('enter name to search')"
          >
          </b-form-input>
        </b-dropdown-text>

        <b-dropdown-item
          v-for="(d, ind) in filteredOptions"
          :key="ind"
          @click="ChangeBranch(d)"
          :active="current == d.id ? true : false"
        >
          {{ d.branch }}
        </b-dropdown-item>

        <b-dropdown-divider />
      </b-dropdown>

      <b-button v-else class="btn-icon" variant="outline-primary" size="sm">
        {{ branchName }}
      </b-button>

      <!-- Messaging icon: WhatsApp or Telegram (from Settings key telegram) -->
      <div
        v-if="showWhatsapp && !useTelegram"
        style="width: 35px; height: 35px"
        class="ml-75 mr-75 position-relative text-center cursor-pointer"
      >
        <b-spinner
          v-if="statusLoading"
          small
          variant="primary"
          label="loading"
          class="mt-75"
        ></b-spinner>

        <div v-else @click="showSidebar()">
          <!-- <b-avatar
            size="35"
            badge
            class="badge-minimal bg-white"
            :badge-variant="
              statusW
                ? statusW.toLowerCase() == 'connected'
                  ? 'success'
                  : 'danger'
                : 'danger'
            "
          >
            <b-img :src="waIcon" fluid-grow alt="whatsapp" />
          </b-avatar> -->

          <b-img :src="waIcon" fluid-grow alt="whatsapp" />
          <feather-icon
            v-if="
              statusW &&
              (statusW.toLowerCase() == 'connected' ||
                statusW.toLowerCase() == 'opening')
            "
            icon="CheckIcon"
            class="text-success status-icons"
            size="18"
          />
          <feather-icon
            v-else
            icon="XIcon"
            class="text-danger status-icons"
            size="18"
          />
        </div>
      </div>
      <div
        v-else-if="showWhatsapp && useTelegram"
        style="width: 35px; height: 35px"
        class="ml-75 mr-75 position-relative text-center cursor-pointer"
      >
        <b-spinner
          v-if="statusLoading"
          small
          variant="primary"
          label="loading"
          class="mt-75"
        ></b-spinner>

        <div v-else @click="showSidebar()">
          <b-img :src="tgIcon" fluid-grow alt="telegram" />
          <feather-icon
            v-if="statusW && statusW.toLowerCase() == 'connected'"
            icon="CheckIcon"
            class="text-success status-icons"
            size="18"
          />
          <feather-icon
            v-else
            icon="XIcon"
            class="text-danger status-icons"
            size="18"
          />
        </div>
      </div>

      <locale v-if="clientID == 'myskool_yakubov'" />

      <notification-dropdown-new
        v-if="
          ((notiObj && notiObj.valueBool) || compNotify || notiAll) &&
          rights['notification-history'] &&
          rights['notification-history'].view
        "
        :data="notificationData"
      />
      <user-dropdown
        :dwObj="dwObj"
        :appObj="appObj"
        :pauseObj="pauseObj"
        :status="statusW"
        :showWa="showWhatsapp"
        :showTelegram="useTelegram"
        :loader="statusLoading"
        @set-loader="setLoader"
        @show-sidebar="showSidebar"
        @telegram-disconnect="handleTelegramDisconnectFromMenu"
      />
    </b-navbar-nav>
  </div>
</template>

<script>
var axios = require("axios");
const TELEGRAM_API_BASE = "https://tel.cloudious.net";

import {
  BLink,
  BNavbarNav,
  BDropdown,
  BDropdownItem,
  BDropdownText,
  BFormGroup,
  BButton,
  BImg,
  BSidebar,
  BCol,
  BRow,
  BForm,
  BSpinner,
  BFormInput,
} from "bootstrap-vue";
import Locale from "./components/Locale.vue";
import NotificationDropdownNew from "./components/NotificationDropdownNew.vue";
import UserDropdown from "./components/UserDropdown.vue";
import { mapActions, mapGetters } from "vuex";
import navMenuItems from "@/navigation/vertical";
import router from "@/router";
import { initialAbility } from "@/libs/acl/config";
import {
  ROLE_COA_ACCESS_SETTING_KEY,
  commitRoleCoaAccessFromSettingsResponse,
} from "@/utils/roleCoaAccess";
import useJwt from "@/auth/jwt/useJwt";
import { $themeConfig } from "@themeConfig";
import { getVueTelEnglishCountries } from "@/libs/vue-tel-english-countries";
import {
  resolveLoginTheme,
  applyBrandDocumentChrome,
  MAK_LOGO_URL,
  brandNameFromReport,
} from "@/views/pages/authentication/loginThemes";
import { isNavGroupActive } from "@core/layouts/utils";
import { prefetchRoute } from "@/utils/routePrefetch";

// ============= Firebase (loaded on demand) ====================
const firebaseConfig = {
  apiKey: "AIzaSyAkVYvsmEbqJ-QsKWtY_Qcw2D_0ifHkiGw",
  authDomain: "ms-whatsapp-node.firebaseapp.com",
  databaseURL: "https://ms-whatsapp-node-default-rtdb.firebaseio.com",
  projectId: "ms-whatsapp-node",
  storageBucket: "ms-whatsapp-node.appspot.com",
  messagingSenderId: "709237835697",
  appId: "1:709237835697:web:b03cf39091a3941fbc1f90",
  measurementId: "G-FR17GV0P2C",
};

let firebaseDbPromise = null;

function getFirebaseDb() {
  if (!firebaseDbPromise) {
    firebaseDbPromise = Promise.all([
      import(/* webpackChunkName: "firebase" */ "firebase/app"),
      import(/* webpackChunkName: "firebase" */ "firebase/database"),
    ])
      .then(([firebaseApp, firebaseDatabase]) => {
        const app = firebaseApp.initializeApp(firebaseConfig);
        return {
          database: firebaseDatabase.getDatabase(app),
          ref: firebaseDatabase.ref,
          onValue: firebaseDatabase.onValue,
          set: firebaseDatabase.set,
        };
      })
      .catch((error) => {
        // Allow retry on a later call if the network/chunk failed.
        firebaseDbPromise = null;
        throw error;
      });
  }
  return firebaseDbPromise;
}
// ============= Firebase ====================

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  components: {
    // VerticalNavMenuItems,
    // Loaded only when the WhatsApp/Telegram sidebar actually needs it.
    LottieAnimation: () =>
      import(
        /* webpackChunkName: "lottie" */ "lottie-vuejs/src/LottieAnimation.vue"
      ),
    BLink,
    BButton,
    BFormGroup,
    BFormInput,
    // Navbar Components
    BSpinner,
    BNavbarNav,
    Locale,
    NotificationDropdownNew,
    UserDropdown,
    BImg,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BSidebar,
    BRow,
    BCol,
    BForm,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      disRetry: true,
      retryID: null,
      retryCount: 15,
      autoScrollInterval: null, // For auto-scroll on hover
      breakpoints: {
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
      i: 0,
      clientID: "",
      firebaseKey: "",
      qrLoading: false,
      qrCode: "",
      visibility: false,
      loading: "https://cdn.cloudious.net/file-1676704112267-760147267.gif",
      // waIcon: "https://cdn.cloudious.net/file-1676700522879-523223941.png",
      waIcon: "https://cdn.cloudious.net/file-1676700040613-583826971.svg",
      waObj: {
        qrCode: "",
        connected: false,
      },
      statusTimer: null,
      showError: false,
      items: [],
      current: this.$store.state.userData.cId,
      navMenuItems,
      // branches: this.$store.state.branches,
      // branchName: "",
      statusW: "",
      statusLoading: true,
      intervalId: null,
      notiInterval: null,
      rights: {},
      campusList: [],
      searchQuery: "",
      notificationData: {
        count: 0,
        data: [],
      },
      compNotify: false,
      notiObj: null,
      compObj: null,
      notiAll: null,
      changingDb: false,
      dwObj: null,
      appObj: null,
      pauseObj: null,
      setupObj: null,
      hpgsCover: require("@/assets/images/logo/hpgs-logo.png"),
      hpgsSmall: require("@/assets/images/logo/hpgs-small.png"),
      szablcCover: require("@/assets/images/logo/szablc-cover.png"),
      szablcSmall: require("@/assets/images/logo/szablc-small.png"),
      useTelegram: false,
      tgIcon:
        "https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg",
      tgPhone: "",
      tgPhoneE164: "",
      tgPhoneError: false,
      tgTelDropdownOptions: {
        disabled: false,
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
      },
      tgCode: "",
      tgOtpStep: false,
      tgConnectLoading: false,
      tgVerifyLoading: false,
      unreadInterval: null,
      pendingNavRoute: null,
      pendingNavTimer: null,
    };
  },
  computed: {
    filteredOptions() {
      return this.branches.filter((pro) => {
        return pro.branch.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    textAdjust() {
      return window.innerWidth <= 768;
    },
    branches() {
      return this.$store.state.branches;
    },
    branchName() {
      return this.$store.state.branchName;
    },
    menuItems() {
      const children = this.$store.state.currentMenu?.children;
      return Array.isArray(children) ? children : [];
    },
    showWhatsapp() {
      let show = false;
      //console.log(this.$store.state.menu);
      const msgRight = this.$store.state.menu.find(
        (el) => el.name == "Messages"
      );
      if (msgRight) {
        msgRight.children.forEach((el) => {
          if (el.route == "apps-chat" || el.route == "apps-groups") {
            show = true;
          }
        });
      }
      return show;
    },
    showSendMsg() {
      let show = true;
      const msgRight = this.$store.state.menu.find(
        (el) => el.name == "Messages"
      );
      if (msgRight && msgRight.children[0].route == "apps-groups") {
        show = false;
      }
      return show;
    },
    showCampus() {
      let show = this.$store.state.permissions == "switch-campus";
      // const camp = this.$store.state.menu.find((el) => el.name == "Home");
      // if (camp) {
      //   let ch = camp.children.find((el) => el.route == "manage-branches");
      //   show = ch && ch.permission == "switch-campus";
      // }
      return show;
    },
    telegramSidebarWidth() {
      return this.useTelegram ? "450px" : undefined;
    },
    tgTelInputOptions() {
      return {
        placeholder: this.$t("Enter a phone number"),
        showDialCode: false,
      };
    },
    tgTelEnglishCountries() {
      return getVueTelEnglishCountries();
    },
    telegramPhoneValid() {
      const p = String(this.tgPhoneE164 || "")
        .trim()
        .replace(/\s/g, "");
      return /^\+\d{10,15}$/.test(p);
    },
    tgPhoneFeedbackState() {
      if (!this.tgPhone || String(this.tgPhone).trim() === "") return null;
      return this.telegramPhoneValid ? true : false;
    },
  },

  async created() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", true);
    this.$store.commit("appConfig/UPDATE_CONTENT_WIDTH", "boxed");
    // console.log(this.$store.state.dbList);
    // console.log(this.$store.state.report);

    if (
      !this.$store.state.userData.password ||
      !this.$store.state.userData.encPassword
    ) {
      this.logout();
    } else {
      const check = await this.checkLogin();
      if (check) {
        this.loadSetting();
        this.loadDbs();

        if (
          window.location.hostname == "connect.hpgs.pk" ||
          window.location.hostname.includes("connect.hpgs")
        ) {
          this.$store.commit("appConfig/UPDATE_COVERIMAGE", this.hpgsCover);
          this.$store.commit("appConfig/UPDATE_APP_LOGOIMAGE", this.hpgsCover);
          try {
            localStorage.setItem("myskool-welcome-brand", "HPGS Connect");
            localStorage.setItem("myskool-splash-theme-id", "hpgs-connect");
            localStorage.setItem("myskool-splash-logo", "/hpgs-logo.png");
            localStorage.setItem("myskool-splash-logo-source", "app");
            localStorage.setItem("myskool-login-cover", "/hpgs-logo.png");
          } catch (e) {
            /* ignore */
          }
        } else if (
          window.location.hostname === "portal.makcollegiate.com" ||
          window.location.hostname.includes("makcollegiate")
        ) {
          this.$store.commit("appConfig/UPDATE_COVERIMAGE", MAK_LOGO_URL);
          this.$store.commit("appConfig/UPDATE_APP_LOGOIMAGE", MAK_LOGO_URL);
          try {
            localStorage.setItem("myskool-welcome-brand", "MAK Collegiate");
            localStorage.setItem("myskool-splash-theme-id", "mak");
            localStorage.setItem("myskool-splash-logo", MAK_LOGO_URL);
            localStorage.setItem("myskool-splash-logo-source", "app");
            localStorage.setItem("myskool-login-cover", MAK_LOGO_URL);
            localStorage.setItem("myskool-favicon", MAK_LOGO_URL);
          } catch (e) {
            /* ignore */
          }
        } else if (window.location.hostname.includes("szablc.edu.pk")) {
          this.$store.commit("appConfig/UPDATE_COVERIMAGE", this.szablcCover);
          this.$store.commit(
            "appConfig/UPDATE_APP_LOGOIMAGE",
            this.szablcSmall
          );
        } else {
          await this.loadBranding();
        }

        // Keep tab title + favicon aligned with school brand (after cover loads)
        const reportBrand = brandNameFromReport(this.$store.state.report);
        const theme = resolveLoginTheme({
          hostname: window.location.hostname,
          report: this.$store.state.report,
          brandName: reportBrand || localStorage.getItem("myskool-welcome-brand") || "",
        });
        applyBrandDocumentChrome(
          theme,
          this.$store.state.appConfig.coverImage
        );
        if (theme && theme.id && theme.id !== "myskool") {
          if (reportBrand) {
            try {
              localStorage.setItem("myskool-welcome-brand", reportBrand);
            } catch (e) {
              /* ignore */
            }
          }
        } else {
          // Default schools: prefer campuses.name from currentBranch
          const branch = this.$store.state.currentBranch;
          const campusName =
            branch && branch.name && String(branch.name).trim() !== "-"
              ? String(branch.name).trim()
              : "";
          if (campusName) {
            try {
              localStorage.setItem("myskool-welcome-brand", campusName);
              localStorage.setItem("myskool-document-title", campusName);
              document.title = campusName;
            } catch (e) {
              /* ignore */
            }
          }
        }

        this.LoadData();

        // === latest ===
        // this.statusLoading = true;
        // // let val = await this.checkClient();
        // let val = "";
        // this.statusLoading = false;
        // if (val) {
        //   // console.log(val);
        //   this.statusW = "";
        //   this.disconnect();
        // }
        // this.statusLoading = true;
        // var obj2 = {
        //   url:
        //     "https://" +
        //     this.$store.state.WAdomain +
        //     "/status?db=" +
        //     this.clientID +
        //     "&cID=" +
        //     this.$store.state.userData.cId +
        //     "&dbEnc=" +
        //     this.$store.state.userData.db,
        //   headers: {
        //     Authorization: "bearer " + this.$store.state.userData.token,
        //   },
        // };
        // var data = await axios(obj2);
        // // console.log(data);
        // this.statusW = data.data.state;
        // this.statusLoading = false;
        // this.intervalId = setInterval(this.checkStatus, 15000);
        // === latest ===

        // ================
        // if (this.intervalId) clearInterval(this.intervalId);
        // if (this.statusW.toLowerCase() == "connected") {
        //   this.intervalId = setInterval(this.checkStatus, 15000);
        // }
        // ================

        // const branch = this.branches.find((el) => el.id == this.current);
        // this.$store.commit("setBranchName", branch.branch);
        // let logo = branch.logo.split("/")[3];
        // this.$store.commit("setLogo", logo);
      } else {
        this.logout();
      }
    }
  },
  watch: {
    "$route.name": {
      immediate: true,
      handler(name) {
        this.clearPendingNav();
        this.syncCurrentMenuForRoute();
        this.$nextTick(() => this.scrollActiveNavTabIntoView(name));
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.enableDragScroll();
    });
    this._navAfterEach = this.$router.afterEach(() => {
      this.clearPendingNav();
    });
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.notiInterval) clearInterval(this.notiInterval);
    if (this.statusTimer) clearInterval(this.statusTimer);
    if (this.autoScrollInterval) clearInterval(this.autoScrollInterval);
    if (this.unreadInterval) clearInterval(this.unreadInterval);
    this.clearPendingNav();
    if (typeof this._navAfterEach === "function") {
      this._navAfterEach();
      this._navAfterEach = null;
    }
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      put: "put",
      delete: "delete",
      postObj: "postObj",
      getString: "getString",
    }),

    enableDragScroll() {
      const container = this.$refs.navButtonsContainer;
      if (!container || container._msDragScrollBound) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      container.addEventListener("mousedown", (e) => {
        if (e.button !== 0) return;
        if (e.target.closest("a, button, .nav-module-btn")) return;
        isDown = true;
        container.style.cursor = "grabbing";
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
      });

      container.addEventListener("mouseleave", () => {
        isDown = false;
        container.style.cursor = "grab";
      });

      container.addEventListener("mouseup", () => {
        isDown = false;
        container.style.cursor = "grab";
      });

      container.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2;
        container.scrollLeft = scrollLeft - walk;
      });

      container.addEventListener("selectstart", (e) => {
        if (isDown) e.preventDefault();
      });

      container._msDragScrollBound = true;
    },

    findMenuGroupForRoute(routeName) {
      const menu = this.$store.state.menu || [];
      if (!routeName || !menu.length) return null;

      return (
        menu.find((group) =>
          (group.children || []).some((child) => child.route === routeName)
        ) || null
      );
    },

    syncCurrentMenuForRoute() {
      const menu = this.$store.state.menu || [];
      const parent = menu.find(
        (group) => group.children && isNavGroupActive(group.children)
      );
      if (!parent) return;

      const current = this.$store.state.currentMenu || {};
      if (current.name !== parent.name) {
        this.$store.commit("setCurrentMenu", parent);
      }
    },

    clearPendingNav() {
      this.pendingNavRoute = null;
      if (this.pendingNavTimer) {
        clearTimeout(this.pendingNavTimer);
        this.pendingNavTimer = null;
      }
    },

    prepareCleanTabSwitch() {
      // Clear any stuck overlay / scroll so the next page lands clean
      if (this.$store.state.app.shallShowOverlay) {
        this.$store.commit("app/TOGGLE_OVERLAY", false);
      }
      try {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
      const content = document.querySelector(".app-content");
      if (content) content.scrollTop = 0;
    },

    prefetchTab(routeName) {
      prefetchRoute(this.$router, routeName);
    },

    onTopTabClick(item, event) {
      if (!item || !item.route) return;
      // Same tab already loading — ignore; different tab can take over
      if (this.pendingNavRoute && this.pendingNavRoute === item.route) return;

      const parent = this.findMenuGroupForRoute(item.route);
      if (parent) {
        this.$store.commit("setCurrentMenu", parent);
      }

      if (this.$route.name === item.route) {
        this.clearPendingNav();
        return;
      }

      this.prepareCleanTabSwitch();
      this.pendingNavRoute = item.route;
      this.scrollNavTabIntoView(event && event.currentTarget);
      if (this.pendingNavTimer) clearTimeout(this.pendingNavTimer);
      // Safety net only. The real clear happens on route change / push settle,
      // so the clicked tab stays highlighted while its chunk is loading.
      this.pendingNavTimer = setTimeout(() => {
        this.clearPendingNav();
      }, 15000);

      this.$router
        .push({ name: item.route })
        .then(() => {
          this.$nextTick(() => {
            this.prepareCleanTabSwitch();
            this.clearPendingNav();
          });
        })
        .catch(() => {
          this.clearPendingNav();
        });
    },

    scrollNavTabIntoView(el) {
      if (!el || typeof el.scrollIntoView !== "function") return;
      try {
        el.scrollIntoView({
          behavior: "auto",
          inline: "center",
          block: "nearest",
        });
      } catch (e) {
        /* ignore */
      }
    },

    scrollActiveNavTabIntoView(routeName) {
      const container = this.$refs.navButtonsContainer;
      if (!container || !routeName) return;
      const el = container.querySelector(
        '[data-nav-route="' + routeName + '"]'
      );
      this.scrollNavTabIntoView(el);
    },

    setFocus() {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
    },

    testing(e) {
      // console.log(e);
      e.preventDefault();
      this.$bvModal.show("modal-campuses");
    },

    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      this.$store.commit("appConfig/UPDATE_CONTENT_WIDTH", "full");

      // Remove userData from localStorage
      localStorage.removeItem("userData");

      // Reset ability
      this.$ability.update(initialAbility);
      this.$store.commit("setPassword", "");
      this.$store.commit("setEncPassword", "");
      this.$store.commit("setDBList", []);
      // Redirect to login page
      if (this.intervalId) clearInterval(this.intervalId);
      if (this.notiInterval) clearInterval(this.notiInterval);
      if (this.unreadInterval) clearInterval(this.unreadInterval);
      this.$store.commit("setUnreadCount", 0);
      this.$router.push({ name: "auth-login" });
    },

    async checkLogin() {
      var config = {
        method: "post",
        url: "https://connect.myskool.app/api/Tokens/UserLogin",
        data: {
          username: this.$store.state.userData.username,
          password: this.$store.state.userData.password,
        },
      };
      try {
        var response = await axios(config);
        // console.log(response.data);
        if (
          response.data.data.role !== "parent" &&
          response.data.data.role !== "student" &&
          response.data.data.role !== "teacher"
        ) {
          var obj = {
            url:
              this.$store.state.domain +
              "Campuses/GetClientID?db=" +
              this.$store.state.userData.db,
            token: this.$store.state.userData.token,
          };
          this.clientID = await this.getString(obj);
          this.$store.commit("setClientID", this.clientID);
          this.$store.commit("setReport", this.$store.state.clientID);
          // console.log(this.$store.state.clientID);
          this.firebaseKey =
            this.clientID + "_" + this.$store.state.userData.cId;

          const code =
            this.clientID == "myskool_yakubov"
              ? 998
              : this.clientID == "myskool_happiness_foundation"
              ? 62
              : 92;
          this.$store.commit("setCountryCode", code);
          // console.log(this.$store.state.countryCode);

          // this.saveLog(response.data.data);
          return true;
        } else {
          return false;
        }
      } catch (error) {
        // console.log(error);
        return false;
      }
    },
    async saveLog(item) {
      // for timezone issue
      const dt = new Date();
      const date = `${dt.getFullYear()}-${(dt.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
      const time = new Date().toTimeString().split(" ")[0];

      const logdate = `${date}T${time}`;

      let obj = {
        id: 0,
        localID: item.localID,
        campusID: item.campusID,
        userType: "user",
        loggedInAt: logdate,
        duration: "",
      };

      let resp = await this.postObj({
        url:
          this.$store.state.domain +
          "UserLoginLog?db=" +
          this.$store.state.userData.db,
        body: obj,
        message: null,
        context: this,
        token: this.$store.state.userData.token,
        ignoreMessage: true,
      });
    },

    RefreshMenu() {
      var config = {
        url:
          this.$store.state.domain +
          "Users/GetSelected?id=" +
          this.$store.state.userData.userID +
          "&db=" +
          this.$store.state.userData.db,
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      };
      axios(config)
        .then((res) => {
          this.$store.commit("setLoggedUser", res.data.data);

          let mm = JSON.parse(res.data.data.forms);
          let obj = mm.find((el) =>
            el.children.find(
              (ch) =>
                !ch.view && !ch.add && !ch.edit && !ch.delete && ch.permission
            )
          );
          // console.log(obj);
          if (obj) {
            let child = obj.children.find(
              (ch) =>
                !ch.view && !ch.add && !ch.edit && !ch.delete && ch.permission
            );
            // console.log(child)
            this.$store.commit("setPermissions", child.permission);

            obj.children = obj.children.filter(
              (el) => el.view || el.add || el.edit || el.delete
            );
            if (obj.children.length == 0) {
              mm = mm.filter((el) => el.id != obj.id);
            } else {
              let ind = mm.findIndex((el) => el.id == obj.id);
              mm.splice(ind, 1, obj);
            }
          } else {
            let other = mm.find((el) =>
              el.children.find((ch) => ch.permission)
            );
            // console.log(other);
            if (other) {
              let otherCh = other.children.find((ch) => ch.permission);
              this.$store.commit("setPermissions", otherCh.permission);
              // console.log(otherCh);
            } else this.$store.commit("setPermissions", "");
          }
          // console.log(mm);

          this.$store.commit("setMenu", mm);
          // this.$store.commit("setMenu", JSON.parse(res.data.data.forms));
          //this.$store.commit("setCurrentMenu", this.$store.state.menu[0]);

          this.$store.state.menu.forEach((el) => {
            el.children.forEach((ch) => {
              const rightObj = {
                view: ch.view,
                add: ch.add,
                edit: ch.edit,
                delete: ch.delete,
                notificationTypes: ch.notificationTypes || [],
                reportTypes: ch.reportTypes || [],
              };
              if (ch.route) this.rights[ch.route] = rightObj;
              if (ch.title) this.rights[ch.title] = rightObj;
            });
          });

          // console.log(this.rights);
          this.$store.commit("setRights", this.rights);
          if (this.$store.state.rights["apps-chat"]) {
            // get unread count
            this.getUnreadCount();
            this.unreadInterval = setInterval(this.getUnreadCount, 15000);
          }

          axios({
            method: "post",
            url:
              this.$store.state.domain +
              "Settings/getSettingsAll?db=" +
              this.$store.state.userData.db,
            data: [ROLE_COA_ACCESS_SETTING_KEY],
            headers: {
              Authorization: "bearer " + this.$store.state.userData.token,
            },
          })
            .then((settingRes) => {
              commitRoleCoaAccessFromSettingsResponse(
                this.$store,
                settingRes.data,
                this.$store.state.userData.cId
              );
            })
            .catch(() => {
              commitRoleCoaAccessFromSettingsResponse(
                this.$store,
                [],
                this.$store.state.userData.cId
              );
            });

          if (this.compObj && this.rights["school-complaints"]) {
            this.LoadComplaints();
            this.compNotify = true;
          }
        })
        .catch((error) => {});
    },
    async LoadComplaints() {
      var obj = {
        url:
          this.$store.state.domain +
          "SchoolComplaints/LoadData?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&categoryID=0",
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (Array.isArray(res)) {
        let count = res.filter(
          (el) => el.us.status.toLowerCase() == "pending"
        ).length;

        if (count > 0) {
          this.notificationData = {
            count: 1,
            data: [
              {
                title: "Complaints",
                body: `You have ${count} pending complaints`,
                isRead: true,
                route: "school-complaints",
              },
            ],
          };
        } else {
          this.notificationData = {
            count: 0,
            data: [],
          };
        }
      }
    },
    loadDbs() {
      var config = {
        method: "post",
        url: "https://connect.myskool.app/api/Tokens/GetDbList",
        data: {
          username: this.$store.state.userData.username,
          password: this.$store.state.userData.encPassword,
        },
      };
      axios(config)
        .then((res) => {
          // console.log(res.data.data);
          this.$store.commit("setDBList", res.data.data);
          if (res.data.data.length > 1) {
            this.loadCampusList();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadCampusList() {
      var config = {
        method: "post",
        url: this.$store.state.domain + "Campuses/GetUserCampusList",
        data: this.$store.state.dbList,
      };
      axios(config)
        .then((res) => {
          // console.log(res.data);
          this.campusList = res.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async loadBranding() {
      var obj = {
        url:
          this.$store.state.domain +
          "branding/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (res.length > 0) {
        let obj = res[0];
        if (obj.webTitle && obj.webTitle !== "-") {
          try {
            localStorage.setItem(
              "myskool-welcome-brand",
              String(obj.webTitle).trim()
            );
          } catch (e) {
            /* ignore */
          }
        }
        if (!obj.webLoginCover || obj.webLoginCover == "-") {
          this.$store.commit(
            "appConfig/UPDATE_COVERIMAGE",
            $themeConfig.app.coverImage
          );
        } else {
          this.$store.commit("appConfig/UPDATE_COVERIMAGE", obj.webLoginCover);
        }
        if (!obj.webLogo || obj.webLogo == "-") {
          this.$store.commit(
            "appConfig/UPDATE_APP_LOGOIMAGE",
            $themeConfig.app.appLogoImage
          );
        } else {
          this.$store.commit("appConfig/UPDATE_APP_LOGOIMAGE", obj.webLogo);
        }
        applyBrandDocumentChrome(
          resolveLoginTheme({
            hostname: window.location.hostname,
            report: this.$store.state.report,
            brandName:
              (obj.webTitle && obj.webTitle !== "-"
                ? String(obj.webTitle).trim()
                : "") ||
              localStorage.getItem("myskool-welcome-brand") ||
              "",
          }),
          this.$store.state.appConfig.coverImage
        );
      } else {
        this.$store.commit(
          "appConfig/UPDATE_COVERIMAGE",
          $themeConfig.app.coverImage
        );
        this.$store.commit(
          "appConfig/UPDATE_APP_LOGOIMAGE",
          $themeConfig.app.appLogoImage
        );
      }
    },

    routeVariant(route) {
      if (this.pendingNavRoute) return this.pendingNavRoute === route;
      if (this.$route.name === route) return true;
      const navActiveLink = this.$route.meta && this.$route.meta.navActiveLink;
      return navActiveLink === route;
    },
    async checkClient() {
      var obj = {
        url:
          this.$store.state.domain +
          "Campuses/validateClient?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      return res;
    },
    async disconnect() {
      var obj2 = {
        url:
          "https://" +
          this.$store.state.WAdomain +
          "/disconnect?db=" +
          this.clientID +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dbEnc=" +
          this.$store.state.userData.db,
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      };
      var data = await axios(obj2);
    },
    async checkStatus() {
      // ================
      // this.statusLoading = true;
      // ================
      // console.log("general");
      try {
        var obj2 = {
          url:
            "https://" +
            this.$store.state.WAdomain +
            "/status?db=" +
            this.clientID +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dbEnc=" +
            this.$store.state.userData.db,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
          },
        };
        var data = await axios(obj2);
        // console.log(data);
        this.statusW = data.data.state;
      } catch (error) {
        // console.log("===", error);
        this.statusW = "";
      }

      // ================
      // this.statusLoading = false;
      // if (this.statusW.toLowerCase() !== "connected") {
      //   clearInterval(this.intervalId);
      // }
    },
    async WhatsApp() {
      //Read from Firebase
      // console.log("==========");
      let firebase;
      try {
        firebase = await getFirebaseDb();
      } catch (error) {
        console.error("Firebase unavailable:", error);
        return;
      }
      const childRef = firebase.ref(firebase.database, this.firebaseKey);
      firebase.onValue(childRef, (snapshot) => {
        var data = snapshot.val();
        if (data == null) {
          data = {
            qrCode: "",
            connected: false,
            newQR: false,
          };
        }
        // console.log("=========== DATA CHANGED ==============");

        this.waObj = data;
        this.i = this.i + 1;
        // console.log(this.waObj);
        if (data != null) {
          // clearInterval(this.retryID);
          this.qrCode = data.qrCode;
          if (data.connected) {
            // console.log("w-connected");
            this.waIcon =
              "https://cdn.cloudious.net/file-1676700040613-583826971.svg";
            //this.visibility = false;

            //  ================
            //if (this.intervalId) clearInterval(this.intervalId);
            this.statusW = "connected";
            //this.intervalId = setInterval(this.checkStatus, 15000);
          } else {
            // console.log("dis");
            // if (this.retryID) clearInterval(this.retryID);
            // this.retryCount = 15;
            // this.disRetry = true;
            // this.retryID = setInterval(this.setRetry, 1000);

            // console.log(data);
            this.qrCode = "";
            this.waIcon =
              "https://cdn.cloudious.net/file-1676700040613-583826971.svg";
          }
        } else {
          this.qrCode = "";
          this.waIcon =
            "https://cdn.cloudious.net/file-1676700040613-583826971.svg";
        }
      });
    },
    async GetQRCode() {
      this.qrLoading = true;
      let firebase;
      try {
        firebase = await getFirebaseDb();
      } catch (error) {
        console.error("Firebase unavailable:", error);
        this.qrLoading = false;
        return;
      }
      firebase.set(firebase.ref(firebase.database, this.firebaseKey), {
        connected: false,
        qrCode: "",
        newQR: true,
      });

      //Hit API
      await this.ConnectAndSend();
    },
    async ConnectAndSend() {
      console.log("Connecting to API...");
      try {
        var params = {
          clientID: this.clientID,
          timeOut: 8000,
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
        };
        let resp = await this.postObj({
          url: "https://" + this.$store.state.WAdomain + "/connect",
          body: params,
          message: null,
          context: this,
          token: this.$store.state.userData.token,
          ignoreMessage: true,
          whatsapp: true,
        });
        console.log(resp, this.waObj);
        // this.$store.state.WAdomain &&
        // this.$store.state.WAdomain.includes("api.whatsappbusiness.ae")
        if (true) {
          this.waObj = resp;

          if (!resp.connected) {
            // Clear any existing timer before setting a new one
            if (this.statusTimer) clearInterval(this.statusTimer);
            // Start a timer to check status every 2.5 seconds
            this.statusTimer = setInterval(this.checkBusinessStatus, 2500);
          }
        } else if (resp != false) {
          this.WhatsApp();
        }
        // else {
        //   this.showError = true;
        // }
      } catch (ex) {
        console.error(ex);
      } finally {
        this.qrLoading = false;
      }
    },
    async checkBusinessStatus() {
      // if (
      //   this.$store.state.WAdomain &&
      //   this.$store.state.WAdomain.includes("api.whatsappbusiness.ae")
      // ) {
      // }
      try {
        var obj2 = {
          url:
            "https://" +
            this.$store.state.WAdomain +
            "/status?db=" +
            this.clientID +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dbEnc=",
        };
        var data = await axios(obj2);

        if (data.data.state === "CONNECTED") {
          // Stop the timer if connected
          if (this.statusTimer) clearInterval(this.statusTimer);
          this.statusTimer = null;

          // Update waObj
          this.waObj.connected = true;
          this.statusW = "connected";
        }
      } catch (error) {
        console.error("Error checking WhatsApp business status:", error);
      }
    },
    hideSideBar() {
      this.visibility = false;
    },
    async checkTelegramStatus() {
      try {
        const { data } = await axios.get(`${TELEGRAM_API_BASE}/status`);
        const statusStr = String(data?.status || "").toLowerCase();
        const authorized = data?.authorized === true;
        // tel.cloudious can return status "connected" before OTP is verified; require authorized
        const ok = !!data && authorized && statusStr === "connected";
        this.statusW = ok ? "connected" : "";
      } catch (e) {
        this.statusW = "";
      }
    },
    async showTelegramSidebar() {
      this.showError = false;
      this.statusLoading = true;
      await this.checkTelegramStatus();
      this.statusLoading = false;
      // Always open sidebar so user can disconnect or start sending messages
      this.visibility = true;
    },
    telegramResetPhoneStep() {
      this.tgOtpStep = false;
      this.tgCode = "";
    },
    telegramClearConnectForm() {
      this.telegramResetPhoneStep();
      this.tgPhone = "";
      this.tgPhoneE164 = "";
      this.tgPhoneError = false;
    },
    onTelegramPhoneInput(value, phoneObj) {
      if (!value || String(value).trim() === "") {
        this.tgPhoneError = false;
        this.tgPhoneE164 = "";
        return;
      }
      if (phoneObj && phoneObj.valid) {
        this.tgPhoneError = false;
        this.tgPhoneE164 = phoneObj.number || "";
      } else {
        this.tgPhoneError = true;
        this.tgPhoneE164 = "";
      }
    },
    telegramPhoneForApi() {
      const p = String(this.tgPhoneE164 || "")
        .trim()
        .replace(/\s/g, "");
      if (!p) return "";
      return p.startsWith("+") ? p : `+${p.replace(/^\+/, "")}`;
    },
    async telegramSendCode() {
      const phone = this.telegramPhoneForApi();
      if (!phone || !this.telegramPhoneValid) return;
      this.tgConnectLoading = true;
      try {
        const { data } = await axios.post(
          `${TELEGRAM_API_BASE}/connect`,
          { phone },
          { headers: { "Content-Type": "application/json" } }
        );
        const st = String(data?.status || "").toLowerCase();
        if (st === "otp_sent") {
          this.tgOtpStep = true;
          this.$bvToast.toast(
            this.$t("Verification code sent. Enter it below."),
            {
              title: this.$t("Telegram"),
              variant: "info",
              toaster: "b-toaster-top-center",
              solid: true,
            }
          );
        } else {
          await this.checkTelegramStatus();
        }
      } catch (e) {
        const detail = e.response?.data?.detail;
        const msg = Array.isArray(detail)
          ? detail.map((d) => d.msg || "").join(" ")
          : typeof detail === "string"
          ? detail
          : e.message || "Request failed";
        this.$bvToast.toast(String(msg), {
          title: this.$t("Telegram"),
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
      } finally {
        this.tgConnectLoading = false;
      }
    },
    async telegramVerifyCode() {
      const phone = this.telegramPhoneForApi();
      const code = String(this.tgCode || "").trim();
      if (!phone || !this.telegramPhoneValid || !code) return;
      this.tgVerifyLoading = true;
      try {
        await axios.post(
          `${TELEGRAM_API_BASE}/connect/verify`,
          { phone, code },
          { headers: { "Content-Type": "application/json" } }
        );
        await this.checkTelegramStatus();
        if (this.statusW && this.statusW.toLowerCase() === "connected") {
          this.$bvToast.toast(this.$t("Telegram connected successfully."), {
            title: this.$t("Connected!"),
            variant: "success",
            toaster: "b-toaster-top-center",
            solid: true,
          });
          this.visibility = false;
          this.tgCode = "";
          this.tgOtpStep = false;
        } else {
          this.$bvToast.toast(this.$t("Could not verify. Try again."), {
            title: this.$t("Telegram"),
            variant: "warning",
            toaster: "b-toaster-top-center",
            solid: true,
          });
        }
      } catch (e) {
        const detail = e.response?.data?.detail;
        const msg = Array.isArray(detail)
          ? detail.map((d) => d.msg || "").join(" ")
          : typeof detail === "string"
          ? detail
          : e.message || "Verification failed";
        this.$bvToast.toast(String(msg), {
          title: this.$t("Telegram"),
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
      } finally {
        this.tgVerifyLoading = false;
      }
    },
    async performTelegramDisconnect() {
      try {
        await axios.post(
          `${TELEGRAM_API_BASE}/disconnect`,
          {},
          { headers: { "Content-Type": "application/json" } }
        );
        await this.checkTelegramStatus();
        this.telegramClearConnectForm();
        this.$bvToast.toast(this.$t("Telegram disconnected."), {
          variant: "success",
          toaster: "b-toaster-top-center",
          solid: true,
        });
      } catch (e) {
        const detail = e.response?.data?.detail;
        const msg =
          (typeof detail === "string" && detail) ||
          e.message ||
          this.$t("Unable to disconnect Telegram.");
        this.$bvToast.toast(String(msg), {
          variant: "danger",
          toaster: "b-toaster-top-center",
          solid: true,
        });
      }
    },
    async telegramDisconnectFromSidebar() {
      await this.performTelegramDisconnect();
    },
    async handleTelegramDisconnectFromMenu() {
      await this.performTelegramDisconnect();
    },
    async checkSidebarStatus() {
      try {
        var obj2 = {
          url:
            "https://" +
            this.$store.state.WAdomain +
            "/status?db=" +
            this.clientID +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dbEnc=" +
            this.$store.state.userData.db,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
          },
        };
        var data = await axios(obj2);
        // console.log(data);
        this.statusW = data.data.state;
        this.statusLoading = false;
        this.intervalId = setInterval(this.checkStatus, 15000);
        return true;
      } catch (error) {
        console.log("===", error?.response);
        // check if error is 502 or CORS or Bad Gateway
        const { response, message } = error;
        const isError =
          response?.status === 502 ||
          message?.includes("CORS") ||
          message?.includes("Bad Gateway");

        // check again after 3.5 seconds
        if (isError) {
          return false;
        }
        this.statusW = "";
        return true;
      }
    },
    async showSidebar() {
      if (this.useTelegram) {
        await this.showTelegramSidebar();
        return;
      }
      //  ================
      this.showError = false;
      this.statusLoading = true;
      // let val = await this.checkClient();
      let val = "";
      this.statusLoading = false;
      if (val) {
        // console.log(val);
        this.statusW = "";
        this.disconnect();
        this.$bvToast.toast(
          this.$t(
            "Your WhatsApp connection is disconnected due to pending payment."
          ),
          {
            title: this.$t("WhatsApp Disconnected!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
            solid: true,
          }
        );
      } else {
        if (this.intervalId) clearInterval(this.intervalId);
        this.statusLoading = true;
        const res = await this.checkSidebarStatus();
        console.log("resp: ", res);
        // if not connected, check again after 3.5 seconds
        if (!res) {
          setTimeout(() => {
            this.showSidebar();
          }, 3500);
          return;
        }
        //  ================
        if (this.statusW && this.statusW.toLowerCase() == "connected") {
          this.$bvToast.toast(this.$t("WhatsApp is already connected."), {
            title: this.$t("Connected!"),
            variant: "success",
            toaster: "b-toaster-top-center",
            solid: true,
          });
        } else {
          this.waObj.connected = false;
          this.waObj.qrCode = "";
          this.visibility = true;

          // this.retryCount = 15;
          // this.disRetry = true;
          // this.retryID = setInterval(this.setRetry, 1000);

          //this.waIcon = this.loading;
          var resp = await this.ConnectAndSend();
          // console.log(resp);
          this.visibility = true;
        }
      }
    },
    setRetry() {
      // console.log(this.retryCount);
      if (this.retryCount == 0) {
        this.disRetry = false;
        clearInterval(this.retryID);
      } else {
        this.retryCount -= 1;
      }
    },
    formatRetryText(count) {
      if (count < 10) return `(00 : 00 : 0${count})`;
      return `(00 : 00 : ${count})`;
    },
    async loadRetry() {
      this.disRetry = true;
      var obj2 = {
        url:
          "https://" +
          this.$store.state.WAdomain +
          "/retry?db=" +
          this.clientID +
          "&cID=" +
          this.$store.state.userData.cId +
          "&dbEnc=" +
          this.$store.state.userData.db,
        headers: {
          Authorization: "bearer " + this.$store.state.userData.token,
        },
      };
      var data = await axios(obj2);
      // console.log(data);
      // var resp = await this.ConnectAndSend();
      if (data.data.state == "-") {
        this.retryCount = 15;
        this.disRetry = true;
        this.retryID = setInterval(this.setRetry, 1000);
        var resp = await this.ConnectAndSend();
      }

      // this.retryCount = 15;
    },
    async loadSetting() {
      let telegramFromAll = null;
      let res2 = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "domain",
          "complaint-notification",
          "notifications-all-campuses",
          "telegram",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      telegramFromAll = res2.find((el) => el.key == "telegram");
      let domain = res2.find((el) => el.key == "domain");
      if (domain && domain.value) {
        this.$store.commit("setDomain", domain.value);
      } else {
        this.$store.commit("setDomain", "https://apiv26.myskool.app/api/");
      }
      this.compObj = res2.find((el) => el.key == "complaint-notification");

      // show notifications dropdown for all campuses
      this.notiAll = res2.find((el) => el.key == "notifications-all-campuses");
      if (this.notiAll) {
        this.loadNoti();
        this.notiInterval = setInterval(this.loadNoti, 30000);
      }
      this.RefreshMenu();

      // Load base-url setting separately - only for API calls
      let baseUrlRes = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: ["base-url"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });

      // Get base-url setting and update domain if found (only for API calls, not report URLs)
      // If base-url is empty or not found, use the normal domain setting (already set above)
      const baseUrlObj = baseUrlRes.find((el) => el.key == "base-url");
      if (baseUrlObj && baseUrlObj.value && baseUrlObj.value.trim() !== "") {
        console.log(
          "Base URL setting from AppNavbarVerticalLayout (cID=" +
            this.$store.state.userData.cId +
            "):",
          baseUrlObj
        );
        console.log("Base URL value:", baseUrlObj.value);

        // Construct API domain from base-url (e.g., "hpgs.myskool.app" -> "https://hpgs.myskool.app/api/")
        let baseUrlValue = baseUrlObj.value.trim();
        // Remove https:// if present
        if (baseUrlValue.startsWith("https://")) {
          baseUrlValue = baseUrlValue.replace("https://", "");
        }
        // Remove http:// if present
        if (baseUrlValue.startsWith("http://")) {
          baseUrlValue = baseUrlValue.replace("http://", "");
        }
        // Remove trailing slash if present
        if (baseUrlValue.endsWith("/")) {
          baseUrlValue = baseUrlValue.slice(0, -1);
        }
        // Construct the full API domain
        const apiDomain = `https://${baseUrlValue}/api/`;
        this.$store.commit("setDomain", apiDomain);
        console.log("API Domain updated to:", apiDomain);
      } else {
        console.log(
          "Base URL setting not found or empty in AppNavbarVerticalLayout (cID=" +
            this.$store.state.userData.cId +
            "), using normal domain"
        );
      }

      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "notifications",
          "dedicatedWhatsApp",
          "applicationId",
          "allowPause",
          "setupURL",
          "telegram",
          // "pausedStatus",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      // console.log(res);
      this.dwObj = res.find((el) => el.key == "dedicatedWhatsApp");
      if (this.dwObj && this.dwObj.valueBool && this.dwObj.value) {
        this.$store.commit("setWAdomain", this.dwObj.value);
      } else {
        this.$store.commit("setWAdomain", "whatsapp.myskool.app");
      }

      this.appObj = res.find((el) => el.key == "applicationId");
      if (this.appObj && this.appObj.valueBool && this.appObj.value) {
        this.$store.commit("setAppID", this.appObj.value);
      } else {
        this.$store.commit("setAppID", "");
      }
      this.setupObj = res.find((el) => el.key == "setupURL");
      if (this.setupObj && this.setupObj.value) {
        this.$store.commit("setSetupUrl", this.setupObj.value);
      } else {
        this.$store.commit("setSetupUrl", "https://setup.whatsappbusiness.ae");
      }
      // console.log(this.$store.state.setupUrl, this.$store.state.appID);

      this.pauseObj = res.find((el) => el.key == "allowPause");
      // console.log(this.pauseObj);
      // console.log(this.dwObj, this.appObj);
      // console.log(this.$store.state.WAdomain, this.$store.state.appID);

      const telegramSetting =
        res.find((el) => el.key == "telegram") || telegramFromAll;
      this.useTelegram = !!(
        telegramSetting &&
        String(telegramSetting.value || "")
          .toLowerCase()
          .trim() === "telegram"
      );

      this.notiObj = res.find((el) => el.key == "notifications");
      // console.log(this.notiObj);
      if (!this.notiAll && this.notiObj && this.notiObj.valueBool) {
        this.loadNoti();
        this.notiInterval = setInterval(this.loadNoti, 30000);
      }

      this.statusLoading = true;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (this.useTelegram) {
        await this.checkTelegramStatus();
        this.statusLoading = false;
        this.intervalId = setInterval(this.checkTelegramStatus, 15000);
      } else {
        await this.checkStatus();
        this.statusLoading = false;
        this.intervalId = setInterval(this.checkStatus, 15000);
      }
      // let report = res.find((el) => el.key == "report");
      // console.log(domain);

      // if (report && report.value == "general") {
      //   this.$store.commit("setReport", "reports");
      // } else {
      //   this.$store.commit("setReport", this.$store.state.clientID);
      //   // console.log(this.$store.state.report);
      // }
    },
    setLoader(val) {
      // console.log(val);
      this.statusLoading = val;
      if (val) {
        if (this.intervalId) clearInterval(this.intervalId);
        setTimeout(() => {
          this.checkAfterLogout();
        }, 15000);
      }
    },
    async checkAfterLogout() {
      if (this.useTelegram) {
        try {
          await this.checkTelegramStatus();
          this.statusLoading = false;
          this.intervalId = setInterval(this.checkTelegramStatus, 15000);
        } catch (error) {
          this.statusW = "";
          setTimeout(() => {
            this.checkAfterLogout();
          }, 15000);
        }
        return;
      }
      // console.log("after");
      try {
        var obj2 = {
          url:
            "https://" +
            this.$store.state.WAdomain +
            "/status?db=" +
            this.clientID +
            "&cID=" +
            this.$store.state.userData.cId +
            "&dbEnc=" +
            this.$store.state.userData.db,
          headers: {
            Authorization: "bearer " + this.$store.state.userData.token,
          },
        };
        var data = await axios(obj2);
        // console.log(data);
        this.statusW = data.data.state;
        this.statusLoading = false;
        this.intervalId = setInterval(this.checkStatus, 15000);
      } catch (error) {
        this.statusW = "";
        setTimeout(() => {
          this.checkAfterLogout();
        }, 15000);
      }
    },
    async getUnreadCount() {
      var obj = {
        url:
          this.$store.state.domain +
          "Chat/LoadUnreadCount?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      const res = await this.get(obj);
      // console.log(res);
      if (res.unreadMessages && res.unreadMessages > 0) {
        this.$store.commit("setUnreadCount", res.unreadMessages);
      } else {
        this.$store.commit("setUnreadCount", 0);
      }
    },
    async loadNoti() {
      var obj = {
        url:
          this.$store.state.domain +
          "Notifications/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
        dashboard: true,
      };
      this.notificationData = await this.get(obj);
      // console.log(this.notificationData);
    },
    async LoadData() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      let response = await this.get(obj);

      // Find head office index
      const headOfficeIndex = response.findIndex(
        (campus) => campus.branch.toLowerCase() === "head office"
      );
      // If head office exists and is not already at the first position
      if (headOfficeIndex > 0) {
        // Remove head office from its current position
        const headOffice = response.splice(headOfficeIndex, 1)[0];
        // Insert at the beginning
        response.unshift(headOffice);
      }
      this.items = response;
      // console.log("item", this.items);

      this.$store.commit("setBranches", this.items);
      const branch = this.items.find(
        (el) => el.id == this.$store.state.userData.cId
      );
      this.$store.commit("setBranchName", branch.branch);
      // console.log(
      //   "Current Branch: ",
      //   JSON.stringify(this.$store.state.currentBranch)
      // );
      // if (JSON.stringify(this.$store.state.currentBranch) === "{}")
      this.$store.commit("setCurrentBranch", branch);
    },
    ChangeBranch(data) {
      // console.log(id, this.$store.state.userData.cId);
      this.$store.commit("campusId", data.id);
      this.$store.commit("setBranchName", data.branch);
      //this.$store.commit("setCurrentBranch", data);

      this.$router.go();
    },
    async ChangeDB(data) {
      // console.log(id, this.$store.state.userData.cId);
      this.$store.commit("campusId", data.id);
      this.$store.commit("setBranchName", data.branch);

      this.$store.commit("setDB", data.organizationType);

      this.changingDb = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Campuses/GetClientID?db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      let res = await this.getString(obj);
      this.$store.commit("setClientID", res);
      this.$store.commit("setReport", res);
      this.$router.go();
    },
  },
};
</script>
<style lang="css">
.mygradient {
  background-image: linear-gradient(47deg, #8074e5, #a79fed);
  /* color: white;
  border: none; */
}
</style>
<style scoped>
@media only screen and (max-width: 768px) {
  .navScroll {
    overflow-x: scroll;
    scroll-behavior: smooth;
    padding: 0.25rem 0;
  }
  .navScroll::-webkit-scrollbar {
    display: none;
  }
  .adjustAlign {
    flex-wrap: unset;
  }
}

.adjustAlign {
  flex-shrink: 0 !important;
  min-width: fit-content;
}

.navbar-container {
  overflow: visible;
  min-width: 0;
  position: relative;
  background: transparent !important;

  @media (max-width: 768px) {
    padding: 0.25rem 0.5rem;
  }
}

.scrolling-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.scrolling-wrapper .btn {
  flex: 0 0 auto;
}

.status-icons {
  position: absolute;
  bottom: -4px;
  right: -10px;
}

/* Nav Buttons Wrapper - Contains scroll zones and container */
.nav-buttons-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 280px);
  width: auto;
  margin-right: auto;

  @media (max-width: 992px) {
    max-width: calc(100% - 200px);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    flex: 1;
  }
}

.nav-module-btn.is-pending {
  cursor: progress;
}

.nav-module-btn.is-pending::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: rgba(255, 255, 255, 0.16);
  animation: nav-tab-pending-pulse 1s ease-in-out infinite;
  pointer-events: none;
}

@keyframes nav-tab-pending-pulse {
  0%,
  100% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.45;
  }
}

/* Thin clean progress under tabs — not a page overlay */
.nav-switch-bar {
  position: absolute;
  left: 0.75rem;
  right: 0.75rem;
  bottom: 0;
  height: 2px;
  border-radius: 2px;
  overflow: hidden;
  pointer-events: none;
  opacity: 0;
  background: transparent;
  transition: opacity 0.12s ease;
  z-index: 2;
}

.nav-switch-bar.is-active {
  opacity: 1;
  background: rgba(115, 103, 240, 0.12);
}

.nav-switch-bar.is-active::after {
  content: "";
  display: block;
  width: 35%;
  height: 100%;
  border-radius: 2px;
  background: #7367f0;
  animation: nav-switch-bar-move 0.75s ease-in-out infinite;
}

@keyframes nav-switch-bar-move {
  0% {
    transform: translateX(-30%);
  }
  100% {
    transform: translateX(320%);
  }
}

/* Scroll zones removed — they intercepted tab clicks */

.nav-buttons-container {
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  gap: 0.75rem;
  padding: 0.45rem 0.75rem;
  width: 100%;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  cursor: grab;
  user-select: none;
  position: relative;
  z-index: 1;

  /* Custom Scrollbar Styling for PC Users */
  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
  }

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  /* Tablet and below */
  @media (max-width: 992px) {
    gap: 0.6rem;
  }

  /* Mobile Responsive - Hide scrollbar, smaller gap and padding */
  @media (max-width: 768px) {
    gap: 0.5rem;
    padding: 0.35rem 0.5rem;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

.nav-buttons-container:active {
  cursor: grabbing;
}

.nav-module-btn {
  position: relative;
  min-width: max-content !important;
  max-width: none !important;
  width: auto !important;
  height: 46px !important;
  min-height: 46px !important;
  max-height: 46px !important;
  padding: 0.45rem 1.25rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  font-size: 1rem !important;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #6f6b7d !important;
  transition: all 0.2s ease;

  @media (max-width: 1200px) {
    padding: 0.4rem 1rem !important;
    font-size: 0.95rem !important;
  }

  @media (max-width: 992px) {
    padding: 0.4rem 0.9rem !important;
    font-size: 0.9rem !important;
  }

  @media (max-width: 768px) {
    height: 38px !important;
    min-height: 38px !important;
    max-height: 38px !important;
    padding: 0.35rem 0.85rem !important;
    font-size: 0.875rem !important;
    border-radius: 6px;
  }
}

.nav-module-btn.btn-gradient-primary {
  border-color: transparent !important;
  color: #fff !important;
}

.adjust-dropdown ::v-deep .dropdown-menu {
  max-height: 350px;
  overflow-y: auto;
}

.search-type:hover {
  background-color: rgba(128, 116, 229, 0.12);
  color: var(--primary);
  transform: scaleY(1.03);
}
.scrollContent {
  height: 50vh;
  overflow-y: auto;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

/* Telegram sidebar — mirrors resource.vue (#add-resource-sidebar) styling only */
#sidebar-right.telegram-resource-sidebar {
  .b-sidebar-body {
    padding: 0 !important;
    overflow-y: auto !important;
    overflow-x: visible !important;
  }

  .b-sidebar-header {
    display: none !important;
  }

  .telegram-sidebar-icon-success {
    color: #22c55e !important;
    stroke-width: 2.5;
  }

  .telegram-connect-lead {
    font-size: 0.875rem;
    line-height: 1.55;
    font-weight: 500;
    color: #64748b;
    margin-bottom: 1.25rem;
    padding: 0.75rem 1rem;
    background: linear-gradient(135deg, #faf9ff 0%, #f8fafc 100%);
    border: 1.5px solid #e0d8ff;
    border-radius: 10px;
  }

  .telegram-connect-lead-sub {
    font-size: 0.8125rem;
    font-weight: 400;
    color: #64748b;
    line-height: 1.45;
  }

  .sidebar-header-modern {
    background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
    border-bottom: 2px solid #e0d8ff;
    padding: 1.25rem 1.5rem;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
    }

    .sidebar-header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;
    }

    .sidebar-title-wrapper {
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    .sidebar-title-icon {
      color: #7c5dfa;
      stroke-width: 2.5;
    }

    .sidebar-title {
      font-size: 1.25rem;
      font-weight: 800;
      color: #2d1b69;
      letter-spacing: -0.3px;
      margin: 0;
    }

    .sidebar-close-btn {
      width: 36px;
      height: 36px;
      padding: 0;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1.5px solid #e0d8ff;
      background: #fff;
      color: #64748b;
      transition: all 0.3s ease;

      &:hover {
        background: #f3f0ff;
        border-color: #b8a9ff;
        color: #7c5dfa;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(124, 93, 250, 0.15);
      }
    }
  }

  .sidebar-body-modern {
    padding: 1.5rem;
    background: #ffffff;
    min-height: calc(100vh - 120px);
  }

  .sidebar-form-modern {
    .modern-form-group {
      margin-bottom: 1.5rem;

      label {
        font-size: 0.875rem;
        font-weight: 600;
        color: #475569;
        margin-bottom: 0.5rem;
        display: block;
      }
    }

    .modern-input {
      border-radius: 10px;
      border: 1.5px solid #e0d8ff;
      padding: 0.625rem 0.875rem;
      min-height: 44px;
      background: #fff;
      transition: all 0.2s ease;
      color: #1e293b;
      font-weight: 500;
      width: 100%;

      &:hover {
        border-color: #b8a9ff;
      }

      &:focus {
        border-color: #7c5dfa;
        box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
        outline: none;
      }

      &.is-invalid {
        border-color: #ef4444;
      }
    }

    .modern-btn-outline {
      border-radius: 10px;
      font-weight: 600;
      padding: 0.625rem 1rem;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }

    .modern-btn-primary {
      border-radius: 10px;
      font-weight: 600;
      padding: 0.75rem 1.25rem;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  .sidebar-footer-modern {
    padding: 1.5rem;
    background: #faf9ff;
    border-top: 2px solid #e0d8ff;
    position: sticky;
    bottom: 0;
    margin: 1.5rem -1.5rem -1.5rem -1.5rem;

    .modern-btn-submit {
      border-radius: 10px;
      font-weight: 600;
      padding: 0.75rem 1.5rem;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }

  .telegram-verify-footer {
    margin-top: 0.5rem;
  }

  /* vue-tel-input — clearer dial code + search + dropdown polish */
  .telegram-tel-wrap .vti__selection {
    gap: 0.35rem;
    align-items: center;
    font-weight: 600;
    font-size: 0.9rem;
  }

  .telegram-tel-wrap .vti__selection .vti__country-code {
    font-weight: 700 !important;
    font-size: 0.95rem !important;
    color: #7c5dfa !important;
    letter-spacing: 0.02em;
    margin-left: 0.15rem !important;
  }

  .telegram-tel-wrap .vti__dropdown.show {
    max-height: none !important;
    overflow: visible !important;
  }

  .telegram-tel-wrap .vti__search_box {
    border-radius: 8px !important;
    border: 1.5px solid #e0d8ff !important;
    padding: 0.5rem 0.75rem !important;
    margin: 0.6rem 0.65rem 0.35rem !important;
    width: calc(100% - 1.3rem) !important;
    box-sizing: border-box !important;
    font-size: 0.875rem !important;
    font-weight: 500 !important;
    color: #1e293b !important;
    outline: none !important;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &::placeholder {
      color: #94a3b8;
      font-weight: 400;
    }

    &:focus {
      border-color: #7c5dfa !important;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.12);
    }
  }

  .telegram-tel-wrap .vti__dropdown-item {
    padding: 0.55rem 0.85rem !important;
    font-size: 0.8125rem !important;
    line-height: 1.35 !important;
    color: #334155 !important;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.15s ease;
  }

  .telegram-tel-wrap .vti__dropdown-item:last-child {
    border-bottom: none;
  }

  .telegram-tel-wrap .vti__dropdown-item.highlighted {
    background: linear-gradient(90deg, #f5f3ff 0%, #faf9ff 100%) !important;
  }

  /* vue-tel-input — align with modern-input borders */
  .telegram-tel-wrap .vue-tel-input {
    width: 100%;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .telegram-tel-wrap .vue-tel-input:focus-within {
    box-shadow: none !important;
  }

  .telegram-tel-wrap .vue-tel-input .vti__dropdown {
    border-radius: 10px 0 0 10px;
    border: 1.5px solid #e0d8ff;
    border-right: none;
    background: #fff;
    min-height: 44px;
    z-index: 11000 !important;
  }

  .telegram-tel-wrap .vti__dropdown:hover {
    border-color: #b8a9ff;
  }

  .telegram-tel-wrap .vti__dropdown.open {
    border-color: #7c5dfa;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.08);
  }

  .telegram-tel-wrap .vti__input {
    border-radius: 0 10px 10px 0 !important;
    border: 1.5px solid #e0d8ff !important;
    border-left: none !important;
    min-height: 44px !important;
    padding: 0.625rem 0.875rem !important;
    font-weight: 500 !important;
    color: #1e293b !important;
  }

  .telegram-tel-wrap .vue-tel-input:focus-within .vti__input {
    border-color: #7c5dfa !important;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.1);
  }

  .telegram-tel-wrap .vue-tel-input:focus-within .vti__dropdown {
    border-color: #7c5dfa;
  }

  .telegram-tel-wrap .vti__dropdown-list {
    max-height: 280px !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    overscroll-behavior: contain;
    z-index: 11000 !important;
    border-radius: 10px !important;
    border: 1.5px solid #e0d8ff !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.12) !important;
    scrollbar-width: thin;
    scrollbar-color: #c4b5fd #f8fafc;
  }

  .telegram-tel-wrap .vti__dropdown-list::-webkit-scrollbar {
    width: 6px;
  }

  .telegram-tel-wrap .vti__dropdown-list::-webkit-scrollbar-track {
    background: #f8fafc;
    border-radius: 6px;
  }

  .telegram-tel-wrap .vti__dropdown-list::-webkit-scrollbar-thumb {
    background: #c4b5fd;
    border-radius: 6px;
  }

  .telegram-tel-wrap .vti__dropdown-list::-webkit-scrollbar-thumb:hover {
    background: #a78bfa;
  }
}
</style>
